var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rules_bg"},[_c('van-button',{staticClass:"index_btn",attrs:{"type":"default","size":"large"},on:{"click":_vm.start}},[_c('img',{attrs:{"src":require("../assets/images/button1.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }